export const checkValidation = (value, validation) => {
  let sanitized = "";
  switch (validation) {
    case "alphabet":
      sanitized = value.replace(/[^A-Za-z\s]/g, "");
      break;
    case "alphanumeric":
      sanitized = value.replace(/[^A-Za-z0-9\s]/g, "");
      break;
    case "numeric":
      sanitized = value.replace(/[^0-9]/g, "");
      break;
    default:
      sanitized = value;
      break;
  }
  return sanitized;
};

export const getDepartmentAccordingBranch = (Branch, value) => {
    const filteredDepartment = Branch.filter(dept => dept.BranchId === value)
    return filteredDepartment;
}

export const getItemsNames = (data) => {
  if (!data ) {
    return [];
  }
    // Map through the Table6 array to extract item names and IDs
    return data.map(item => ({
      label: item.ItemName, // Use ItemName for the label
      value: item.ItemId    // Use ItemId for the value
    }));
}


export const getTransactionDetail = (changedRecords) => {
  return changedRecords.map(item => ({
    "ItemId": item.ItemId,
    "UnitId": item.IssuanceUnitId, // Assuming this is the intended field
    "Quantity": Number(item.Quantity),
    "Rate": Number(item.Rate)
  }));
};
export const encrypt = (data) => {};
export const decrypt = (data) => {};
export const getLocalItem = (key) => localStorage.getItem(key);
export const setLocalItem = (key, value) => localStorage.setItem(key, value);
export const removeLocalItem = (key, value) => localStorage.removeItem(key);
